import { useId } from 'react';

export function Logo({ className }: { className?: string }) {
  const gradientId = `beeGrad${useId().replaceAll(':', '')}`;

  return (
    <svg
      viewBox="0 0 320 120"
      xmlns="http://www.w3.org/2000/svg"
      className={`logo-svg ${className ?? ''}`}
      role="img"
      aria-label="MCPForge — Secure Database Gateway for AI"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FBBF24" />
          <stop offset="100%" stopColor="#F97316" />
        </linearGradient>
      </defs>
      <g transform="translate(18 22)">
        <rect
          className="logo-mark-bg"
          width="72"
          height="72"
          rx="18"
          fill="#292016"
          stroke={`url(#${gradientId})`}
          strokeWidth="2"
        />
        <path
          d="M36 13 L54 20 V35 C54 47 46 55 36 60 C26 55 18 47 18 35 V20 Z"
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <path
          className="logo-mark-lines"
          d="M27 29 H45 M27 36 H45 M27 43 H40"
          stroke="#FEF3C7"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <circle cx="49" cy="48" r="7" fill="#FBBF24" stroke="#292016" strokeWidth="2" />
        <path
          d="M46 48 L48 50 L52 45"
          stroke="#292016"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <text className="logo-name" x="106" y="55" fill="#F8FAFC" fontSize="29" fontWeight="700" fontFamily="Inter, Arial">
        MCPForge
      </text>
      <text className="logo-tagline" x="106" y="77" fill="#FCD9A5" fontSize="12">
        Secure Database Gateway for AI
      </text>
    </svg>
  );
}
